import React from 'react';
import { changePercent } from '../utils/reportingUtils';

const TrendBadge = ({ current, prior, label, delta }) => {
  const pct = delta !== undefined
    ? (delta == null ? null : delta.toFixed(1))
    : changePercent(current, prior);
  if (pct == null) return null;
  const isPositive = parseFloat(pct) >= 0;
  const color = isPositive ? '#8AC926' : '#FF595E';
  const arrow = isPositive
    ? 'M2 8 L6 3 L10 8 M6 3 L6 13'
    : 'M2 5 L6 10 L10 5 M6 10 L6 0';

  return (
    <div style={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', gap: '0 4px', fontSize: 13, lineHeight: '18px' }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
        <svg width="14" height="14" viewBox="0 0 12 14" fill="none" style={{ flexShrink: 0 }}>
          <path d={arrow} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span style={{ fontWeight: 600, color }}>{isPositive ? pct : pct.replace('-', '')}%</span>
      </span>
      <span style={{ color: 'var(--sl-text-tertiary, #667085)', fontWeight: 400, fontSize: 12 }}>{label}</span>
    </div>
  );
};

export default TrendBadge;
